"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = require("../main");
var React = __importStar(require("react"));
var genIcon = function (icon, props, badgeProps) {
    if (React.isValidElement(icon)) {
        var classes = '';
        var className = props.className, cleanedProps = __rest(props, ["className"]);
        var i = icon;
        var iClassName = i.props.className;
        classes += className;
        if (iClassName) {
            classes += " " + iClassName;
        }
        var combinedProps = Object.assign(cleanedProps, i.props, { className: classes });
        return React.cloneElement(i, combinedProps);
    }
    else if (typeof icon === 'string') {
        if (badgeProps && badgeProps.content) {
            var color = props.color, cleanedProps = __rest(props, ["color"]);
            var mappedBadgeProps = __assign(__assign({}, cleanedProps), { name: icon, color: badgeProps.color, badge: badgeProps.content, empty: !badgeProps.content, iconColor: color });
            return React.createElement(main_1.BadgedIcon, __assign({}, mappedBadgeProps));
        }
        else {
            return React.createElement(main_1.Icon, __assign({ name: icon }, props));
        }
    }
    return null;
};
exports.default = genIcon;
